<!------------------------------------------------------------------------------
  - Copyright (c) 2019. BMW Group. All rights reserved.
  ----------------------------------------------------------------------------->

<app-generic-modal [primaryActionTitle]="primaryActionTitle"
                   [title]="title"
                   [primaryActionEnabled]="isValid"
                   (primaryActionEvent)="save()"
                   secondaryActionTitle="Discard">
    <div class="business-modal-body">
        <app-input-text #claimCodeName
                        label="Claim code name"
                        placeholder="Please, write a claim code name"
                        baseCypressTag="business-settings-claim-code-modal-name"
                        [warningLevel]="WarningsEnum.WARNING_SAVE"
                        [maxLength]="100"
                        [validators]="validators.name"
                        [messages]="nameMessages"
                        (inputValueChange)="nameInputChange($event)"></app-input-text>

        <app-input-text #claimCode
                        label="Claim code"
                        placeholder="Please, write a claim code, e.g. 000"
                        baseCypressTag="business-settings-claim-code-modal-code"
                        [warningLevel]="WarningsEnum.WARNING_SAVE"
                        [maxLength]="3"
                        [validators]="validators.code"
                        [messages]="codeMessages"
                        (inputValueChange)="codeInputChange($event)"></app-input-text>

        <div fieldset id="requires-justification-input-form" class="modal-radio-input">

            <div class="modal-info-label"
                 data-cy="business-settings-claim-codes-requires-attachments-label">Requires attachments?</div>

            <div class="modal-radio-input-option">
                <input type="radio" id="yes" name="requires-attachments"
                       (change)="requiresAttachmentsInputChange(true)"
                       [checked]="$safeNavigationMigration(state?.currentValue?.requiresAttachments)"
                       data-cy="business-settings-claim-code-modal-radio-button-yes">
                <label for="yes" class="modal-radio-input-label">Yes</label>
            </div>
            <div class="modal-radio-input-option">
                <input type="radio" id="no" name="requires-attachments"
                       (change)="requiresAttachmentsInputChange(false)"
                       [checked]="!state?.currentValue?.requiresAttachments"
                       data-cy="business-settings-claim-code-modal-radio-button-no">
                <label for="no" class="modal-radio-input-label">No</label>
            </div>
        </div>

        <app-active-input [entityName]="ENTITY_NAME" [state]="$safeNavigationMigration(state?.isActive)"
                          (checkState)="setActiveInputState($event)"></app-active-input>
    </div>

</app-generic-modal>
